import { render, staticRenderFns } from "./casePage.vue?vue&type=template&id=c98396e6&scoped=true"
import script from "./casePage.vue?vue&type=script&lang=js"
export * from "./casePage.vue?vue&type=script&lang=js"
import style0 from "./casePage.vue?vue&type=style&index=0&id=c98396e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98396e6",
  null
  
)

export default component.exports